import { Commercial, Edit } from '@talon/web/lib/api';
import { Box, Button, Layer, Text } from 'grommet';
import { Close } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { borderRadiusSize } from 'src/theme';
import { Divider } from '../Divider';
import { TalonVideoPlayer } from '../TalonVideoPlayer';

export interface IWatchVideoModalProps {
  commercial: Commercial;
  edit: Edit;
  videoUrl: string;
  setShowModal: (isVisible: boolean) => void;
}

export const WatchVideoModal = observer(({ commercial, edit, videoUrl, setShowModal }: IWatchVideoModalProps) => {
  return (
    <Layer
      onEsc={() => setShowModal(false)}
      onClickOutside={() => setShowModal(false)}
      position="center"
      modal={true}
      margin="large"
      background="none"
    >
      <Box width="888px" background="black" round={borderRadiusSize}>
        <Box direction="row" justify="between" align="center" pad={{ vertical: 'xsmall', horizontal: 'small' }}>
          <Text weight={600}>
            {commercial.title} - {edit.title}
          </Text>
          <Button icon={<Close />} onClick={() => setShowModal(false)} />
        </Box>
        <Divider height="1px" />
        <Box height="500px" justify="center" overflow="auto">
          <TalonVideoPlayer url={videoUrl} controls={true} />
        </Box>
      </Box>
    </Layer>
  );
});
